import React from 'react';
import { Button, Text } from "../../../Components/Themed"
import type { PublicPlayerProps, TextTagProps } from "../../../types"
import { Image } from 'react-native';

type PlayerTagProps = {
    tag:TextTagProps,
    player?:PublicPlayerProps,
    onPress: (tag:TextTagProps, data?:PublicPlayerProps) => void
}

const PlayerTag = ({ tag, player, onPress }:PlayerTagProps) => {

    if(!player){
        return (
            <Button transparent style={{ padding:0 }} onPress={() => onPress(tag, player)}>
                <Text theme='action'>{tag.tag} </Text>
            </Button>
        )
    }
    return (
        <Button float style={{ flexDirection:'row', alignItems:'center', padding:5, borderRadius:100, margin:5, marginLeft:0 }} onPress={() => onPress(tag, player)}>
            <Image
                source={{ uri: player.profile_pic }}
                style={{ height:20, width:20, borderRadius:100 }}
                resizeMode='cover'
            />
            <Text style={{ marginLeft:5 }} theme='description'>{player.username}</Text>
        </Button>
    )
}

export default PlayerTag